import { paymentCollectionForGrid } from '../../../spd/components/PaymentCollection/PaymentCollectionsSearch';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import {
  DefaultApi,
  GetPaymentCollectionDto,
} from '../autogenerated/spdApiClient';

export interface PaymentCollectionsContextInterface {
  getById: (id: string) => Promise<GetPaymentCollectionDto>;
  getAllByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
  ) => Promise<GridRecord[]>;
  getAllCount: (filterText?: string, filterColumns?: string) => Promise<number>;
}

export const PaymentCollectionsContext = (
  api: DefaultApi,
): PaymentCollectionsContextInterface => ({
  getById: (id: string) => api.paymentCollectionControllerGet(id),

  async getAllByPortion(
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
  ) {
    const response = await api.paymentCollectionControllerGetAllByPortion(
      pageSize,
      pageNumber,
      orderBy || '',
      orderDirection || '',
      filterText || '',
      filterColumns,
    );
    return response.map(paymentCollectionForGrid);
  },

  async getAllCount(filterText?: string, filterColumns?: string) {
    return api.paymentCollectionControllerGetAllCount(
      filterText || '',
      filterColumns,
    );
  },
});
